import { useState } from "react";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import { AnimatePresence, motion } from "framer-motion";

export default function AdjustmentNotice() {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="flex flex-col gap-2 mt-4 p-4 bg-blue-50 border-l-4 border-blue-400 rounded-lg text-sm text-blue-900 shadow-sm">
      {/* Main Content */}
      <div className="flex items-start gap-3">
        <HiOutlineExclamationCircle className="w-5 h-5 mt-0.5 flex-shrink-0 text-blue-600" />

        <div className="flex flex-col gap-1">
          <span className="font-semibold text-blue-900">
            Accurate measurements required
          </span>

          <span className="text-blue-800 flex items-center gap-2 flex-wrap">
            Carriers verify all shipments. Incorrect dimensions or weight may
            result in extra adjustment charges.
            <button
              onClick={() => setExpanded(!expanded)}
              className="text-xs font-medium text-blue-800 bg-blue-200 hover:bg-blue-300 px-2 py-0.5 rounded-full transition-colors"
            >
              {expanded ? "Hide details ▲" : "Learn more ▼"}
            </button>
          </span>
        </div>
      </div>

      {/* Animated Details */}
      <AnimatePresence initial={false}>
        {expanded && (
          <motion.div
            key="details"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.2 }}
            className="overflow-hidden mt-2 text-xs text-blue-700 leading-relaxed space-y-1"
          >
            <p>
              Carriers re-measure every package during processing. If your
              provided length, width, height, or weight is incorrect, the
              carrier may apply an additional adjustment fee.
            </p>
            <p>
              By continuing, you confirm your measurements are accurate and you
              agree to be responsible for any adjustment charges the carrier may apply.
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}